import app from './app';
import eventCreate from './eventCreate';
import eventList from './eventList';
import eventDashboard from './eventDashboard';
import adminEventList from './adminEventList';
import adminEventCreate from './adminEventCreate';
import adminVenueList from './adminVenueList';
import adminCityList from './adminCityList';
import adminRequestedEventList from './adminRequestedEventList';
import adminPrimaryEventEdit from './adminPrimaryEventEdit';
import adminPrimaryEventList from './adminPrimaryEventList';
import adminPrimaryOrganizersList from './adminPrimaryOrganizersList';
import adminPrimaryOrganizersEdit from './adminPrimaryOrganizersEdit';
import adminFinishedEventsList from './adminFinishedEventsList';
import adminDeletedEventsList from './adminDeletedEventsList'
import adminLiveAndUpcomingEventsList from './adminLiveAndUpcomingEventsList';
import landingPage from './landingPage';
import allEvents from './allEvents';
import buyerFlow from './buyerFlow';
import sellTickets from './sellTickets';
import userListing from './userListing';
import primaryBuyerFlow from './primaryBuyerFlow';
import bookingsList from './bookingsList';
import adminCancelledEventsList from './adminCancelledEventsList';
import adminRescheduledEventsList from './adminRescheduledEventsList';

export default {
  app,
  eventCreate,
  eventList,
  eventDashboard,
  // admin panel
  adminEventList,
  adminEventCreate,
  adminVenueList,
  adminCityList,
  adminRequestedEventList,
  adminPrimaryEventEdit,
  adminPrimaryEventList,
  adminPrimaryOrganizersList,
  adminPrimaryOrganizersEdit,
  adminFinishedEventsList,
  adminDeletedEventsList,
  adminCancelledEventsList,
  adminRescheduledEventsList,
  adminLiveAndUpcomingEventsList,
  allEvents,
  landingPage,
  buyerFlow,
  sellTickets,
  userListing,
  primaryBuyerFlow,
  bookingsList,
};
